import React from "react";
import { ImageOverlay } from "../elements/headerComponents";
import { Section, Card, Image } from "../elements/bodyComponents";
//import { BodyCopy } from '../typography/typography';
import { CheckVis, ShowPage, HidePage } from "../helpers/helpers";
//import { Button } from '../elements/buttons';
import { RecipePromo } from "../elements/recipes";
import throttle from "es6y-throttle/dist/throttle";
import { BuildImagePath } from "../helpers/helpers";

//styles
import "../css/products.css";

//data
import { Products } from "../json/products";
import { Config } from "../json/config";

/*
    Homepage
*/
export class ProductGroup extends React.Component {
  constructor(props) {
    super(props);
    this.params = this.props.match.params;

    this.getProducts = this.getProducts.bind(this);
    this.showCards = this.showCards.bind(this);

    this.state = {
      type: null,
      color: null,
      productGroup: null,
      scrollHandler: throttle(() => this.showCards(), 150)
    };
  }

  getProducts(type) {
    return Products[type];
  }

  getColor(type) {
    return Config.colors[type];
  }

  /*
        Build Card Components
    */
  buildProductCards(products) {
    //check if we need to add empty cards
    return products.map(p => (
      <ProductCard
        key={p.id}
        flip={true}
        type={this.state.type}
        color={this.state.color}
        id={p.id}
        title={p.name}
        description={p.description}
        image={p.image}
      />
    ));
  }

  /*
        Show Cards in group
    */
  showCards() {
    console.log("show cards");
    if (this.group !== null) {
      if (
        CheckVis(this.group, "quarterScreen", "top") &&
        this.group.classList.contains("visible") === false
      ) {
        this.group.classList.add("showFlipCards");
      }
    }
  }

  /*
        called when new params are passed to the component, like changing between projects
    */
  componentWillReceiveProps(nextProps) {
    if (this.state.type !== nextProps.match.params.group) {
      document
        .querySelector(".globalNav")
        .setAttribute("data-activepage", nextProps.match.params.group);

      setTimeout(this.showCards, 500);

      ShowPage();

      this.setState({
        type: nextProps.match.params.group,
        color: this.getColor(nextProps.match.params.group),
        productGroup: this.getProducts(nextProps.match.params.group)
      });
    }
  }

  /*
        called when component first loads, not called for changes
    */
  componentDidMount() {
    window.addEventListener("scroll", this.state.scrollHandler);
    document
      .querySelector(".globalNav")
      .setAttribute("data-activepage", this.params.group);

    setTimeout(this.showCards, 500);

    ShowPage();

    this.setState({
      type: this.params.group,
      color: this.getColor(this.params.group),
      productGroup: this.getProducts(this.params.group)
    });
  }

  //remove scroll listener when component unmounts
  componentWillUnmount() {
    window.removeEventListener("scroll", this.state.scrollHandler);
    HidePage();
  }

  render() {
    //get recipes
    //let recipes = this.getRecipes();

    let products = [];
    let title = null;
    let subtitle = null;
    let headers = {
      left: null,
      right: null
    };
    let category = null;
    let color = "yellow";

    if (this.state.productGroup !== null) {
      //products = this.buildProductCards( ShuffleArray( this.state.productGroup.items ) );
      products = this.buildProductCards(this.state.productGroup.items);
      title = this.state.productGroup.title;
      subtitle = this.state.productGroup.intro;
      headers.left = this.state.productGroup.header.left;
      headers.right = this.state.productGroup.header.right;
      category = this.state.type.substr(0, this.state.type.length - 1);
    }

    let masterCardWidth = "";
    if (this.state.type === "sauces" || this.state.type === "mealKits") {
      masterCardWidth = "width-medium";
    }

    const imageSizeArray = [
      {
        w: 480,
        name: "small"
      },
      {
        w: 4000,
        name: "large"
      }
    ];

    if (this.state.color !== null) {
      color = this.state.color;
    }

    return (
      <div
        className="layout-productGroup usingMasterCard"
        data-type={this.state.type}
      >
        <header className="pageHeader">
          <ImageOverlay classes="introOverlay text-align-center">
            <h1 className="headline uppercase color-gray">{title}</h1>
            <h3
              className="sectionTitle margin-top-xsmall font-louisana color-gray"
              dangerouslySetInnerHTML={{ __html: subtitle }}
            />
            {/*<BodyCopy classes="color-gray margin-top-medium">
                            Our globally inspired salad dressings, cooking sauces, and meal kits make trying new and exciting flavors more convenient than ever. Take cues from the latest food trends to create your own beautiful, share-worthy dishes.
                        </BodyCopy>
                        <Benefits classes="justify-center margin-top-medium" /> */}
          </ImageOverlay>
          <div className="header-background">
            <img
              className="left"
              src={BuildImagePath(headers.left, "headers", imageSizeArray)}
              alt=""
            />
            <img
              className="right"
              src={BuildImagePath(headers.right, "headers", imageSizeArray)}
              alt=""
            />
          </div>
        </header>

        <Section
          classes={`products masterCard padding-y-xlarge padding-x-xlarge ${masterCardWidth}`}
        >
          <div
            className="grid fourColumn spacing-y-xlarge"
            ref={el => (this.group = el)}
          >
            {products}
          </div>
        </Section>

        {this.state.type !== "mealKits" && (
          <Section classes="recipesIntro flex padding-y-xlarge">
            <Image
              src={`/img/fullWidth/recipe_${this.state.type}_medium.jpg`}
              sizes="(max-width: 1600px) 100vw, 1600px"
              srcSet={`/img/fullWidth/recipe_${
                this.state.type
              }_large.jpg 2702w, /img/fullWidth/recipe_${
                this.state.type
              }_medium.jpg 1801w, /img/fullWidth/recipe_${
                this.state.type
              }_small.jpg 1441w, /img/fullWidth/recipe_${
                this.state.type
              }_xsmall.jpg 1081w, /img/fullWidth/recipe_${
                this.state.type
              }_mbl.jpg 850w`}
              classes="recipesIntro-image"
              alt="Recipe Intro"
            />
            <ImageOverlay classes="recipesIntro-overlay text-align-center color-white">
              <h1 className="headline uppercase">{category} Recipes</h1>
              <h3
                className="sectionTitle font-louisana margin-top-xsmall"
                dangerouslySetInnerHTML={{ __html: subtitle }}
              />
            </ImageOverlay>
          </Section>
        )}

        {this.state.type !== null &&
          this.state.type !== "mealKits" && (
            <RecipePromo
              category={this.state.type}
              color={color}
              max="4"
              classes="margin-bottom-large padding-x-xlarge"
              URL={`/recipes?category=${this.state.type}`}
            />
          )}
      </div>
    );
  }
}

export class ProductCard extends React.Component {
  render() {
    let buttonConfig = {
      size: "secondary",
      color: this.props.color,
      text: "Learn More"
    };
    if (this.props.buttonType === "text") {
      buttonConfig.size = "textOnly arrowRight";
    }

    return (
      <Card
        type="product"
        category={this.props.type}
        flip={this.props.flip}
        title={this.props.title}
        desc={this.props.description}
        color={this.props.color}
        classes="flex-equalSize text-align-center"
        image={this.props.image.small}
        link={`/products/${this.props.type}/${this.props.id}`}
        button={buttonConfig}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/layouts/allProducts.js